
export const SCROLL_TOP_OFFSET = 400;

export const STYLES_INPUT_PANEL_ID = 'stylesInputPanel';

/** Fallback swatch color when a color row has no value yet. */
export const DEFAULT_PANEL_COLOR_HEX = '#ffffff';
/** Default i18n key for the primary color row label. */
export const DEFAULT_CONTENT_COLOR_LABEL_KEY = 'color';

export type ApplyStylesHandler = (selectedColor: string, selectedFont: string, selectedImageURL?: string) => void;
export type ApplyBrandKitHandler = (selectedColorHex?: string, selectedFontFamily?: string, selectedImageURL?: string, secondColorHex?: string) => void;
/** Apply a content + background color together atomically (brand kits with two colors). */
export type ApplyColorPairHandler = (contentHex: string, backgroundHex: string) => void;
export type ColorChangeHandler = (newColor: string) => void;
export type FontChangeHandler = (newFontFamily: string) => void;
export type ImageChangeHandler = (newImageURL: string) => void;
export type GAEventsMap = Partial<Record<StylesInputPanelGAEventType, string>>

export enum StylesInputPanelSection {
    DEFAULT = 'default',
    COLORS = 'colors',
    BACKGROUND_COLOR = 'background-color',
    FONTs = 'fonts'
}

/** Legibility feedback shown in the color sections when a custom background is in play. */
// Re-exported, not redeclared: the event page and the events calendar share one legibility state
// machine in the color library, and a second copy of this enum here could drift from it.
import {LegibilityStatus} from '@Libraries/event-colors.library';

export {LegibilityStatus};

export interface LegibilityState {
    status: LegibilityStatus;
    onUndo?: VoidFunction;
    onFix?: VoidFunction;
    onDismiss?: VoidFunction;
}

export interface StylesInput {
    selectedColorHex: string;
    selectedFontFamily?: string;
    selectedImageURL?: string
}

export interface StylesInputContentParams {
    selectedColorHex: string;
    onSelectColorHex: ColorChangeHandler;
    selectedFontFamily: string;
    selectedImageURL?: string;
    onSelectFontFamily?: FontChangeHandler;
    onImageUploadStart?: () => void;
    onSelectImage?: ImageChangeHandler;
    allowImageSelection?: boolean;
    className?: string;
    gaEventsMap?: GAEventsMap;
    /** Opt-in: show a second "Background color" row and enable the background color section. */
    showBackgroundColorRow?: boolean;
    selectedBackgroundColorHex?: string;
    onSelectBackgroundColorHex?: ColorChangeHandler;
    /** i18n key for the primary color row label (defaults to "color"; event surfaces use "content color"). */
    contentColorLabelKey?: string;
    /** Opt-in: legibility feedback banner state for the color sections. */
    legibility?: LegibilityState;
    /** Opt-in: apply a brand kit's first two colors (content + background) atomically. */
    onApplyColorPair?: ApplyColorPairHandler;
}

export interface StylesInputPanelProps extends StylesInputContentParams {
    onClose?: VoidFunction;
}

export enum StylesInputPanelGAEventType {
    IMAGE = 'image',
    COLOR = 'color',
    FONT = 'font',
    BRAND_KIT = 'brand_kit'
}